import React, { useState } from "react";

interface Category {
  id: string;
  label: string;
}

interface CategoryFiltersProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
  onAddCategory: (label: string) => void;
}

export const CategoryFilters: React.FC<CategoryFiltersProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
  onAddCategory,
}) => {
  const [showAddInput, setShowAddInput] = useState(false);
  const [newCategoryName, setNewCategoryName] = useState("");

  const handleAddCategory = () => {
    if (newCategoryName.trim()) {
      onAddCategory(newCategoryName.trim());
      setNewCategoryName("");
      setShowAddInput(false);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          className="rounded-full px-4 py-2 text-sm font-medium transition-colors"
          style={{
            background: activeCategory === category.id ? "#0051FF" : "white",
            color: activeCategory === category.id ? "white" : "#334155",
            border: activeCategory === category.id ? "none" : "1px solid #E2E8F0",
          }}
        >
          {category.label}
        </button>
      ))}

      {showAddInput ? (
        <div className="flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5">
          <input
            type="text"
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleAddCategory()}
            placeholder="Category name"
            className="w-28 bg-transparent text-sm text-slate-700 placeholder:text-slate-400 outline-none"
            autoFocus
          />
          <button
            onClick={handleAddCategory}
            className="flex h-6 w-6 items-center justify-center rounded-full text-white"
            style={{ background: "linear-gradient(90deg, #00B8DB 0%, #2B7FFF 100%)" }}
          >
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button
            onClick={() => { setShowAddInput(false); setNewCategoryName(""); }}
            className="flex h-6 w-6 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100"
          >
            <svg width="8" height="8" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L9 9M1 9L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
      ) : (
        <button
          onClick={() => setShowAddInput(true)}
          className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
        >
          Add other
        </button>
      )}
    </div>
  );
};

export default CategoryFilters;
